import { useState } from "react";
import { refreshToken } from "../modules/auth/Services";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const useHandleRequestWithRefresh = () => {
  const { auth, login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleRefreshToken = (errorCode, requestFn)=> {
    if (errorCode === 401) {
        return refreshToken(auth.refresh_token)
        .then((res) => {
            const newToken = res?.data?.data?.access_token;
            if (newToken) {
                login({
                    token: newToken,
                    refresh_token: auth.refresh_token,
                    user: auth.user,
                });
                // Retry the original request
                setLoading(true);
                return requestFn();
            } else {
                login({
                    token: null,
                    refresh_token: null,
                    user: null,
                    csrf_token: null
                });
                localStorage.removeItem('auth');
                toast.error("Your session has expired. Please log in again.");
                navigate("/");
                return Promise.reject(new Error('Session expired'));
            }
        })
        .catch(() => {
            setLoading(false);
            login({
                token: null,
                refresh_token: null,
                user: null,
            });
            localStorage.removeItem('auth');
            navigate("/");
            toast.error("Your session has expired. Please log in again.");
            throw { refreshFailed: true };
            // return Promise.reject(err);
        });
    }
    return Promise.resolve();
  }
  
  const handleRequestWithRefresh = async (requestFn) => {
    setLoading(true);
    try {
        const response = await requestFn();
        // If 401, handle refresh first
        if (response?.response?.data?.code === 401) {
            return await handleRefreshToken(response.response.data.code, requestFn);
        }
        return response;
    } catch (error) {
        if (error.response?.data?.code === 401) {
            return await handleRefreshToken(error.response.data.code, requestFn);
        }
        throw error; // If error is not 401, throw it normally
    } finally {
        setLoading(false);
    }
  };

  return {handleRequestWithRefresh, loading};
};
